import { routing } from '@/Support/Routing/Functions/routing'
import { RoutingParams } from '@/Support/Routing/Interfaces/routing'
import { TeamPreferencesInterface } from '@/Support/Teams/Interfaces/TeamPreferencesInterface'

export const update = async (data: RoutingParams) => {
  await window.axios.put(routing('teams.team.update.preferences'), data)
}

type PreferencesKey = keyof TeamPreferencesInterface
export const toggle = async (
  field: PreferencesKey,
  preferences: TeamPreferencesInterface,
) => {
  preferences[field] = !preferences[field]
  await update({ preferences } as unknown as RoutingParams)
}

export const save = async (
  field: PreferencesKey,
  preferences: TeamPreferencesInterface,
  value: boolean | string[],
) => {
  preferences[field] = value
  await update({ preferences } as unknown as RoutingParams)
}

export const reset = async () => {
  return await window.axios.delete(routing('teams.team.reset.preferences'))
}
